import React from 'react'

const DeliveredOrderPeykTable = () => {
  return (
    <div>DeliveredOrderPeykTable</div>
  )
}

export default DeliveredOrderPeykTable